import state from "./state";
var userRole = require("./modules/user-role/user-roles");

export default {
  getGlobalCtx: (state) => state.globalContext,
  getProjectStatues: (state) => state.projectStatuses || [],
  getProjectVesselIds: (state) => state.projectVesselIds || [],
  getVesselNames: (state) => state.vesselNames || [],
  getProjectVesselMappings: (state) => state.projectVesselMappings || [],

  
  getLoggedIn(state) {
    return state.user !== undefined && null != state.user;
  },

  getLoggedInUser(state) {
    return state.user;
  },

  isAdmin: (state) => userRole.ADMINISTRATOR_ROLE == state.userRole || userRole.REPORTING_ADMIN_ROLE == state.userRole, 
  isProjectAdmin: (state) => userRole.PROJECT_ADMIN_ROLE == state.userRole,
  isViewer: (state) => userRole.VIEWER_ROLE == state.userRole,
  isClientViewer: (state) => userRole.CLIENT_VIEWER_ROLE == state.userRole,

  getLoadingApp(state) {
    return state.loadingapp;
  },
  getPrintMode(state) {
    return state.printmode;
  },
  getLongLoader(state) {
    return state.longloader;
  },
  getLongLoaderMessage(state) {
    return state.longloader.message;
  },
  getErrorMessage(state) {
    return state.errormessage;
  },
  getInfoMessage(state) {
    return state.infomessage;
  },
  
  /// ------------ TO BE CHECKED & REMOVED ------------

  getProjectsNames(state) {
    return state.projectsNames
  },
  getActivityTypes(state) {
    return state.activityTypes
  },
  getActCategories(state) {
    return state.activityCategories
  },

  getMaxCode(state) {
    return state.maxedCode
  },

  getActivityMaster(state) {
    return state.activityMaster
  },
  getVessels(state) {
    return state.vessels || []
  },
  getTools(state) {
    return state.tools
  },
  getCables(state) {
    return state.cables
  },
  // getMacroActivities(state) {
  //   return state.macroActivities
  // },
  getProjects(state) {
    return state.projects
  },
  getSoil(state) {
    return state.soils
  },
  getProjectsInVessel(state) {
    return state.projectsInVessel
  },
  getProjectById(state) {
    return state.project
  },
  getActivityConfigurations(state) {
    return state.activityConfigurations
  },
  getTrenchers(state) {
    return state.trenchers
  },
  getConfigurations() {
    return state.configurations
  },
  getQhse() {
    return state.qhse
  },
  getEquipmentStatus() {
    return state.equipmentStatus
  },
  getAreas() {
    return state.areas
  },
  getVesselList() {
    return state.vesselList
  },
  getEstimates() {
    return state.estimates
  },

  // ----
  getNextSeqCode: (state) => (entity) => {
    return entity ? state.nextSeqCode[entity] : state.maxedCode;
  },

  getUnassignedVessels: (state) => {
    return state.unassignedVessels;
  },
  getComputers(){
    return state.computers;
  },
  getProjectsInComputer(){
    return state.projectsInComputer;
  }
}
